// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Basic card styling */
.product-card {
  position: relative;
  overflow: hidden;
  border: none;
  border-radius: 8px;
  box-shadow: 0 0 10px 2px #000000;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  --bs-card-bg: #000;
  text-align: left; 
}

/* Smooth zoom effect on hover */
.product-card:hover {
  transform: scale(1.03);
}

/* Product image styling */
.product-card img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

/* Card body styling */
.product-card-body {
  padding: 14px;
  background: linear-gradient(to top, #4f013d, rgba(54, 0, 44, 0.8));
  color: white;
}

/* Product name styling */
.product-card .card-title {
  font-size: 12px;
  font-weight: bold;
  margin: 0;
  color: #ffffff;
}

/* Product description styling */
.product-card .card-text {
  font-size: 14px;
  margin: 8px 0 0 0;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;  
  overflow: hidden;
  text-overflow: ellipsis;
  color: #d1d1d1;
  text-align: left;
  max-height: 8em;
  line-height: 1.4em;
}

/* Price styling */
.product-card .product-price {
  font-size: 1rem;
  font-weight: bold;
  color: #b8e986;
}

/* Button styling (optional) */
.product-buttons a {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px 0;
  text-align: center;
  color: white;
  background-color: #007bff;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.2s ease;
}

.product-buttons a:hover {
  background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/components/ProductCard.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kEAAkE;EAClE,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Basic card styling */\n.product-card {\n  position: relative;\n  overflow: hidden;\n  border: none;\n  border-radius: 8px;\n  box-shadow: 0 0 10px 2px #000000;\n  transition: transform 0.2s ease-in-out;\n  cursor: pointer;\n  --bs-card-bg: #000;\n  text-align: left; \n}\n\n/* Smooth zoom effect on hover */\n.product-card:hover {\n  transform: scale(1.03);\n}\n\n/* Product image styling */\n.product-card img {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n/* Card body styling */\n.product-card-body {\n  padding: 14px;\n  background: linear-gradient(to top, #4f013d, rgba(54, 0, 44, 0.8));\n  color: white;\n}\n\n/* Product name styling */\n.product-card .card-title {\n  font-size: 12px;\n  font-weight: bold;\n  margin: 0;\n  color: #ffffff;\n}\n\n/* Product description styling */\n.product-card .card-text {\n  font-size: 14px;\n  margin: 8px 0 0 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: vertical;  \n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #d1d1d1;\n  text-align: left;\n  max-height: 8em;\n  line-height: 1.4em;\n}\n\n/* Price styling */\n.product-card .product-price {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #b8e986;\n}\n\n/* Button styling (optional) */\n.product-buttons a {\n  display: block;\n  width: 100%;\n  margin-top: 10px;\n  padding: 10px 0;\n  text-align: center;\n  color: white;\n  background-color: #007bff;\n  border-radius: 5px;\n  text-decoration: none;\n  transition: background-color 0.2s ease;\n}\n\n.product-buttons a:hover {\n  background-color: #0056b3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
